import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('@/components/public/Index')
const Admin = () => import('@/components/admin/Index')
const AdminDefault = () => import('@/components/admin/DefaultCreate')
const Create = () => import('@/components/admin/Create')
// const FirstLevel = () => import('@/components/admin/FirstLevel')
const SecondLevel = () => import('@/components/admin/SecondLevel')
const Api = () => import('@/components/public/Api')
const ApiList = () => import('@/components/public/ApiList')
const ApiDetail = () => import('@/components/public/ApiDetail')
const ApiBuy = () => import('@/components/public/ApiBuy')
const Success = () => import('@/components/public/Success')
const ApiBuyConfirm = () => import('@/components/public/ApiBuyConfirm')
const Recharge = () => import('@/components/public/Recharge')
const Diff = () => import('@/components/public/Diff')
const NotFound = () => import('@/components/common/NotFound')

Vue.use(Router)

export default new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  routes: [
    {
      path: '/',
      component: Index
    },
    {
      path: '/buy',
      component: ApiBuy
    },
    {
      path: '/buyconfirm',
      component: ApiBuyConfirm
    },
    {
      path: '/recharge',
      component: Recharge
    },
    {
      path: '/list',
      component: Api,
      children: [
        {
          path: '',
          component: ApiList
        },
        {
          path: 'detail/:id',
          component: ApiDetail
        }
      ]
    },
    {
      path: '/diff',
      component: Diff
    },
    {
      path: '/admin',
      component: Admin,
      children: [
        {
          path: '',
          component: AdminDefault
        },
        {
          path: 'create',
          component: Create
        },
        // {
        //   path: 'first/:id',
        //   component: FirstLevel
        // },
        {
          path: 'second/:id',
          component: SecondLevel
        }
      ]
    },
    {
      path: '/success',
      component: Success
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js